// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Caml_option = require("rescript/lib/js/caml_option.js");

function arrayBuffer(arrayBuffer$1) {
  return arrayBuffer$1;
}

function blob(blob$1) {
  return blob$1;
}

function string(usvString) {
  return usvString;
}

var Data = {
  arrayBuffer: arrayBuffer,
  blob: blob,
  string: string
};

function makeWithArrayBuffer(arrayBuffer, name, type_, lastModified, param) {
  var tmp = {};
  if (type_ !== undefined) {
    tmp.type = Caml_option.valFromOption(type_);
  }
  if (lastModified !== undefined) {
    tmp.lastModified = Caml_option.valFromOption(lastModified);
  }
  return new File([arrayBuffer], name, tmp);
}

function makeWithBlob(blob, name, type_, lastModified, param) {
  var tmp = {};
  if (type_ !== undefined) {
    tmp.type = Caml_option.valFromOption(type_);
  }
  if (lastModified !== undefined) {
    tmp.lastModified = Caml_option.valFromOption(lastModified);
  }
  return new File([blob], name, tmp);
}

function makeWithString(domString, name, type_, lastModified, param) {
  var tmp = {};
  if (type_ !== undefined) {
    tmp.type = Caml_option.valFromOption(type_);
  }
  if (lastModified !== undefined) {
    tmp.lastModified = Caml_option.valFromOption(lastModified);
  }
  return new File([domString], name, tmp);
}

function t_encode(file) {
  return "File#name=" + file.name;
}

function t_decode(json) {
  return {
          TAG: /* Error */1,
          _0: {
            path: ".",
            message: "We are not suppose to decode JSON into DOME__File.t",
            value: json
          }
        };
}

exports.Data = Data;
exports.makeWithArrayBuffer = makeWithArrayBuffer;
exports.makeWithBlob = makeWithBlob;
exports.makeWithString = makeWithString;
exports.t_encode = t_encode;
exports.t_decode = t_decode;
/* No side effect */
